import React from "react";

import icon_l from "../src/icon/linkedin.png";
import icon_f from "../src/icon/facebook.png";
import icon_i from "../src/icon/instagram.png";

const Footer = () => {
  return (
    <footer
      style={{
        fontSize: "11px",
        backgroundColor: "darkred",
        color: "white",
        textAlign: "center",
        width: "100%",
        position: "relative",
      }}
    >
      <a
        href="https://www.facebook.com/profile.php?id=100008399616995&fref=ts"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={icon_f}
          alt="Facebook"
          style={{
            width: "30px",
            margin: "5px",
          }}
        />
      </a>
      <a
        href="https://www.instagram.com/div_spettrometriadimassa?igshid=YmMyMTA2M2Y%3D"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={icon_i}
          alt="Instagram"
          style={{
            width: "30px",
            margin: "5px",
          }}
        />
      </a>
      <a
        href="https://www.linkedin.com/company/spettrometria-di-massa/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={icon_l}
          alt="LinkedIn"
          style={{
            width: "30px",
            margin: "5px",
          }}
        />
      </a>
      Divisione di Spettrometria di Massa della Società Chimica Italiana © 2025
    </footer>
  );
};

export default Footer;
